import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 80,
	viewBox: "0 0 65 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_10069_8354)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M55.7224 2.10156H8.47994C7.1664 2.10156 6.10156 3.16453 6.10156 4.47576V66.8274C6.10156 68.1387 7.1664 69.2016 8.47994 69.2016H55.7224C57.0359 69.2016 58.1008 68.1387 58.1008 66.8274V4.47576C58.1008 3.16453 57.0359 2.10156 55.7224 2.10156Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M55.7222 2.25H8.47973C7.24828 2.25 6.25 3.24653 6.25 4.47581V66.8275C6.25 68.0568 7.24828 69.0533 8.47973 69.0533H55.7222C56.9536 69.0533 57.9519 68.0568 57.9519 66.8275V4.47581C57.9519 3.24653 56.9536 2.25 55.7222 2.25Z",
				fill: "white",
				stroke: "#D0D5DD",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_10069_8354)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24.3828 27.7578V27.1016H25.6953V27.7578C25.6953 29.2076 26.8706 30.3828 28.3203 30.3828H28.9766V31.0391V31.6953H28.3203C26.8706 31.6953 25.6953 32.8706 25.6953 34.3203V34.9766H25.0391H24.3828V34.3203C24.3828 32.8706 23.2076 31.6953 21.7578 31.6953H21.1016V31.0391V30.3828H21.7578C23.2076 30.3828 24.3828 29.2076 24.3828 27.7578Z",
					fill: "#2E90FA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.1328 33.0078V33.6641H38.8203V33.0078C38.8203 32.2829 38.2327 31.6953 37.5078 31.6953H36.8516V31.0391V30.3828H37.5078C38.2327 30.3828 38.8203 29.7952 38.8203 29.0703V28.4141H39.4766H40.1328V29.0703C40.1328 29.7952 40.7204 30.3828 41.4453 30.3828H42.1016V31.0391V31.6953H41.4453C40.7204 31.6953 40.1328 32.2829 40.1328 33.0078Z",
					fill: "#2E90FA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.1358 33.5714L32.2578 32.3516H33.5703L33.6923 33.5714C34.0031 36.6793 36.4614 39.1375 39.5692 39.4483L40.7891 39.5703V40.8828L39.5692 41.0047C36.4614 41.3155 34.0031 43.7739 33.6923 46.8817L33.5703 48.1016H32.2578L32.1358 46.8817C31.825 43.7739 29.3668 41.3155 26.2589 41.0047L25.0391 40.8828V39.5703L26.2589 39.4483C29.3668 39.1375 31.825 36.6793 32.1358 33.5714Z",
					fill: "#2E90FA"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_10069_8354",
			x: 0,
			y: 0,
			width: 64.2021,
			height: 79.3037,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10069_8354"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_10069_8354",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10069_8354",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				fill: "white",
				transform: "translate(21.1016 27.1016)"
			})
		})] })
	]
});
export default SvgOtherThumbnail;
